import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { ROTARY_TURKEY_IMAGE_SRC } from '../data/rotaryTurkeyContent';

/**
 * Türkiye'de Rotary — URL: /rotary-in-turkey
 */
export function RotaryTurkeyPage() {
    const { t } = useTranslation();

    const paragraphs = useMemo(() => {
        const raw = t('rotaryTurkey.paragraphs', { returnObjects: true });
        return Array.isArray(raw) ? raw : [];
    }, [t]);

    return (
        <>
            <PageSeo
                title={`${t('rotaryTurkey.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.rotaryTurkey')}
            />
            <SubpageLayout
                title={t('rotaryTurkey.title')}
                subtitle={t('rotaryTurkey.subtitle')}
                contentClassName="rotary-turkey-page"
            >
            <div className="row g-4 g-xl-5 align-items-start">
                <div className="col-lg-5 col-xl-5">
                    <figure className="rotary-turkey-figure mb-0">
                        <img
                            src={ROTARY_TURKEY_IMAGE_SRC}
                            alt={t('rotaryTurkey.imageAlt')}
                            className="rotary-turkey-hero-img"
                            loading="lazy"
                            decoding="async"
                        />
                        <figcaption className="rotary-turkey-figure-caption">
                            {t('rotaryTurkey.figureCaption')}
                        </figcaption>
                    </figure>
                </div>
                <div className="col-lg-7 col-xl-7">
                    <div className="rotary-turkey-prose">
                        {paragraphs.map((text, i) => (
                            <p key={i} className="rotary-turkey-prose-p mb-0">
                                {text}
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </SubpageLayout>
        </>
    );
}
